import React from 'react';
import './EventDetail.scss';

export type EventDetailProps = {
    ariaLabelledBy?: string;
};

export const ICON_COLOR = 'ui-purple';
export const ICON_SIZE = 'xsmall';

export const EventDetail: React.FC<EventDetailProps> = ({
    children,
    ariaLabelledBy,
}) => {
    return (
        <section aria-labelledby={ariaLabelledBy} className="event-detail">
            {children}
        </section>
    );
};

export const EventDetailIcon: React.FC = ({ children }) => {
    return <div className="event-detail__icon">{children}</div>;
};

export const EventDetailContent: React.FC = ({ children }) => {
    return <div className="event-detail__content">{children}</div>;
};

export const EventDetailHeading: React.FC = ({ children }) => {
    return <div className="event-detail__heading">{children}</div>;
};
